<template>
  <router-view />
</template>

<script>
export default {
  name: 'Support'
  // child's container
}
</script>



// WEBPACK FOOTER //
// src/views/Support/Support.vue